import styles from "./behindnavbar.module.scss"

const BehindNavBar = () => <div className={styles.behindNavBar}></div>
export default BehindNavBar